import {React, useState} from 'react'
import './home.css'
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { FaTiktok } from 'react-icons/fa';
import ImageGallery from './ImageGallery';
import { collection, addDoc } from "firebase/firestore"; 
import { db } from '../firebase';

export default function Home() {
    window.onbeforeunload = function () {
        window.scrollTo(0, 0);
        };

        const convertKitapiKey = "Lp2UT_puQiynNdsASmou-A";
        // const convertKitSecretKey = "TEdWvLuCEg3cVOmXv9YpkIOjKtx0jTXEjIzcVp8-6T8";
        const convertKitFormID = "5113142";
        
        // subscribe to newsletter google form
        const [subscriber, setSubscriber] = useState('');
        const subscribe = (e) => {
          e.preventDefault();
          // save email in firestore collection called subscribers
          addDoc(collection(db, "subscribers"), {
            email: subscriber,
          });
            // add email to convertkit use fetch

            fetch(`https://api.convertkit.com/v3/forms/${convertKitFormID}/subscribe`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',

                },
                body: JSON.stringify({
                    api_key: convertKitapiKey,
                    email: subscriber,
                })
            })
            .then((response) => response.json())
            .then((data) => {
                console.log("data..: ", data);
                // show success message for 5 seconds
                const successMessage = document.querySelector('.subscribe_newsletter_form p');
                successMessage.style.display = 'block';
                setTimeout(() => {
                    successMessage.style.display = 'none';
                }, 5000);

                setSubscriber('');
            }
            )
            .catch((error) => {
                console.error('Error:', error);
            }
            );


        };



  return (
    <div className='home'>
         <div className="video-container">
      <video autoPlay loop muted playsInline>
        <source src={require("./realestate.mp4")} type="video/mp4" />
      </video>
      <div className="video-content">
        <h1>Get a Home for yourself today!</h1>
        <p>Home Solutions and Property Realtors</p>
      </div>
    </div>

<div className="some-content-wrapper">
<div className="some-content">
    <h1>What we have in store for you</h1>
    <p>An excellent real estate professional, integrity, in-depth community and market knowledge, marketing savvy, effective negotiation skills and a high-quality professional network, all of which are hallmarks of how Paragon works. Contact us today to learn more about real estate and homes for sale!</p>

<div className="sc-desc">
<h1>Get the best Collection On Sale</h1>
<p>,Get your dream place that is popular right now
    <br/> 
    and get the sale of the year</p>
</div>
<button onClick={() => {window.location.href = "properties";}}
>
    View All
</button>

  
<div className="image-gallery">

<div className="gallery_subs_wrapper">

<div className="subscribe_newsletter">
    <h1>
        Stay Tuned
    </h1>
    <p>
    Subscribe to our website to get the latest updates on our available properties, the latest news, and much more!
    </p>
    <div className="subscribe_newsletter_form">
        <form  onSubmit={subscribe}
        >
            <input type="email" required value={subscriber} onChange={(e) => setSubscriber(e.target.value)}
             placeholder="Enter your email" />
             <button type="submit" style={{
                    // border: 'none',
                    // background: 'none',
                    // outline: 'none',
                    // padding: '0',
                    // margin: '0',
             }}>
            {/* <SendIcon
            sx={{
                color: '#85d6ff',
                fontSize: '2rem',
                cursor: 'pointer',
                '&:hover': {
                    color: 'black',
                    transition: '0.3s ease-in-out',
                },
                '&:active': {
                    animation: '$bounce 0.2s ease-in-out',
                },
                '@keyframes bounce': {
                    '0%': {
                        transform: 'translateY(0px)',
                    },
                    '50%': {
                        transform: 'translateY(-10px)',
                    },
                    '100%': {
                        transform: 'translateY(0px)',
                    },
                },
                
            }}
            /> */}
            Subscribe
            </button>

{/* success popup */}
<p style={{
    display: 'none',
    color: 'green',
    fontSize: '1rem',
    opacity: '0.7',
}}
>
Thank you for Subscribing  We sent a confirmation email to your email address. Please click on the link in the email to confirm your subscription.
</p>
        </form>
</div>
</div>

    <ImageGallery 
    className="inner_image_gallery"
    />
    </div>
    </div>
</div>
</div>

<div className="advert">
    <div className="first-ad">
    <div className="first-ad-wrapper">
        <div className="first-ad-content">
            <h1>Discover the best properties in Kenya with Paragon</h1>
            <p>Find you dream home with ease - Explore our diverse range of properties and discover the perfect one for you!</p>
            </div>
          

            <div className="get-started">
                <button 
                onClick={() => {window.location.href = "properties";}} >
                    Get Started <span>&#62;</span>
                </button>
            </div>
</div>
    </div>

    <div className="advert-content">

<h1>
    We offer a variety of properties, including houses, apartments, and land for sale or rent, and provide personalized service.
</h1>
    </div>

</div>


<div className="know-me">
    <div className="ceo-wrapper">
    <div className="ceo-pic">
        <img src={require("./ceo.jpeg")} alt="ceo" />
    </div>
    <div className="ceo-details">
        <h1>Jefferson Munene</h1>
        <h2 className='ceo-position'>Paragon, Founder & CEO</h2>
        <div className="primary-phone">
            <p>Primary Phone</p>
            <h2 className='ceo-phone'>
                <a href="tel:+254104141843">
                (254)104141843</a></h2>
        </div>
        <div className="primary-email">
            <p>Email</p>
            <h3>
                <a href="mailto:ask.sirjefferson@gmail.com">
                    ask.sirjefferson@gmail.com</a>
                </h3>
        </div>
        <div className="social_link-icons">
            <a href="https://www.facebook.com/JeffersonMunene.official?mibextid=ZbWKwL"><FacebookOutlinedIcon fontSize='large' 
                // onhover, change color to #4267B2
                sx={{
                    color: "#303030",
                    '&:hover': {
                        // opacity: [0.5, 0.6, 0.7],
                        transition: "all 0.5s ease-in-out",
                        color: "#4267B2"
                     }
                }}
                className="social_link_icon"/>
                </a>
                <a href="https://instagram.com/jefferson_munene.official?igshid=ZDdkNTZiNTM="><InstagramIcon fontSize='large' className="social_link_icon"
                sx={{
                    color: "#303030",
                    '&:hover': {
                        // opacity: [0.5, 0.6, 0.7],
                        transition: "all 0.5s ease-in-out",
                        color: "#E1306C"
                     }
                }}
                /></a>
                <a href="https://www.linkedin.com/in/jefferson-munene-707233241"><LinkedInIcon fontSize='large'
                sx={{
                    color: "#303030",
                    '&:hover': {
                        // opacity: [0.5, 0.6, 0.7],
                        transition: "all 0.5s ease-in-out",
                        color: "#2867B2"
                     }
                }}
                 className="social_link_icon"/>
                </a>
                <a href="https://twitter.com/MuneneJefferson?t=PHs9P0KkPIXrNImVeVLaXg&s=09"><TwitterIcon fontSize='large'
                sx={{
                    color: "#303030",
                    '&:hover': {
                        // opacity: [0.5, 0.6, 0.7],
                        transition: "all 0.5s ease-in-out",
                        color: "#1DA1F2"
                     }
                }}
                 className="social_link_icon"/>
                </a>
                <a href="http://"><YouTubeIcon fontSize='large'
                sx={{
                    color: "#303030",
                    '&:hover': {
                    //    opacity: [0.5, 0.6, 0.7],
                        transition: "all 0.5s ease-in-out",
                       color: "#FF0000"
                    }

                }}
                 className="social_link_icon"/>
                </a>
                <a href="http://"> <FaTiktok size={"1.6rem"}
                style={{
                    color: "#000000",
                    '&:hover': {
                        opacity: [0.5, 0.6, 0.7],
                        }
                }}  
                 className="social_link_icon"/>
                </a>
                
                
        </div>
    </div>
    </div>
<div className="know-me-title">
<h1>Get To Know Me</h1>

<hr/>

<p>
Meet Jefferson Munene
</p>
<p>
A consistent top producer and real estate enthusiast in Kisii Township and has assisted hundreds of people, both students and working class in their property search and/or sale of their homes. He has been recognized for house hunting agency services efficiency, offering cleaning/ laundry services and property maintenance.
</p>
<p>
A resident since 2021, Jefferson believes in giving back to the Kisii community and has been involved in leadership roles for various boards and organizations.
</p>
</div>
</div>

<div className="final-advert">
    <div className="final-advert-overlay">
    <h1>Work with Paragon</h1>
    <hr/>
    <p>We provide professional property management services to aspiring property owners, either corporate bodies or individuals on issues regarding; Real Estate Management, Property Brokerage, Property Marketing /Acquisition and Real Estate Consultants.</p>

    <button 
    // go to contact page
    onClick={() => window.location.href='/contact'}
    >
        Let's Connect
    </button>
    </div>
</div>


    </div>
  ) 
}
